<template>
  <div
    class="status-card"
    @mouseover="showChecklistStatus = true"
    @mouseleave="showChecklistStatus = false"
  >
    <div v-if="error" class="error-msg">{{ error }}</div>

    <!-- Group status - always visible -->
    <div class="status-line">Group Status: <span :class="statusColorClass(status.groupStatus)">{{ groupStatusLabel }}</span></div>

    <!-- Checklist status - slides down on hover -->
    <div class="checklist-panel" :class="{ visible: showChecklistStatus }">
      <div class="status-line">Checklist Status: <span :class="statusColorClass(status.surveyStatus)">{{ surveyStatusLabel }}</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SurveyStatus',
  props: {
    fetchUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      status: {
        groupStatus: null,
        groupStatusDate: null,
        surveyStatus: null
      },
      showChecklistStatus: false,
      loading: false,
      error: null
    }
  },
  computed: {
    groupStatusLabel() {
      if (!this.status.groupStatus) return 'UNKNOWN'
      let normalized = this.status.groupStatus.replace(/_/g, ' ')
      return this.status.groupStatusDate ? `${normalized} (as of ${this.status.groupStatusDate})` : normalized
    },
    surveyStatusLabel() {
      return this.status.surveyStatus ? this.status.surveyStatus.replace(/_/g, ' ') : 'UNKNOWN'
    }
  },
  watch: {
    '$store.state.survey.lastSaved'() {
      this.fetchStatus()
    },
    fetchUrl() {
      this.fetchStatus()
    }
  },
  mounted() {
    this.fetchStatus()
  },
  methods: {
    statusColorClass(rawStatus) {
      if (rawStatus === 'CERTIFIED') return 'status-certified'
      if (['DECERTIFIED', 'GRACE', 'EXPIRED'].includes(rawStatus)) return 'status-decertified'
      return ''
    },
    fetchStatus() {
      this.loading = true
      this.error = null
      this.$http.get(this.fetchUrl)
        .then(response => {
          this.status = response.data
        })
        .catch(err => {
          this.error = 'Could not load status.'
          console.error('SurveyStatus fetch error:', err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.status-card {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 12px 16px;
  text-align: center;
  cursor: default;
}

.status-line {
  font-size: 14px;
  font-weight: bold;
}

.status-certified {
  color: green;
}

.status-decertified {
  color: red;
}

.error-msg {
  font-size: 12px;
  color: #c62828;
  margin-bottom: 8px;
}

.checklist-panel {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transition: max-height 0.4s ease, opacity 0.4s ease;
}

.checklist-panel.visible {
  max-height: 40px;
  opacity: 1;
}
</style>
